import { gql } from '@apollo/client';
import { CreateScanRuleInput, DeleteScanRuleInput, ScanRule, UpdateScanRuleInput } from '../types/scan_rule';
import { forPaginated } from './common/paginated.graphql';

const scanRule = gql`
  fragment ScanRule on ScanRule {
    id
    version
    companyId
    type
    configurationValues {
      field
      key
      stringValue
      stringArrayValue
    }
  }
`;

const get = gql`
  query scanRules($page: Float) {
    scanRules(page: $page) {
      data {
        ...ScanRule
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${scanRule}
`;

export interface GetScanRuleVariables {
  page?: number;
}

export interface GetScanRuleResponse {
  scanRules: PaginatedScanRule;
}

class PaginatedScanRule extends forPaginated<ScanRule>() {}

const create = gql`
  mutation CreateScanRule($scanRules: [CreateScanRuleInput!]!) {
    createScanRule(scanRules: $scanRules) {
      ...ScanRule
    }
  }
  ${scanRule}
`;

export interface CreateScanRuleVariables {
  scanRules: CreateScanRuleInput[];
}

export interface CreateScanRuleResponse {
  createScanRule: ScanRule[];
}

const update = gql`
  mutation UpdateScanRule($scanRules: [UpdateScanRuleInput!]!) {
    updateScanRule(scanRules: $scanRules) {
      ...ScanRule
    }
  }
  ${scanRule}
`;

export interface UpdateScanRuleVariables {
  scanRules: UpdateScanRuleInput[];
}

export interface UpdateScanRuleResponse {
  updateScanRule: ScanRule[];
}

const remove = gql`
  mutation DeleteScanRule($scanRules: [DeleteScanRuleInput!]!) {
    deleteScanRule(scanRules: $scanRules) {
      ...ScanRule
    }
  }
  ${scanRule}
`;

export interface DeleteScanRuleVariables {
  scanRules: DeleteScanRuleInput[];
}

export interface DeleteScanRuleResponse {
  deleteScanRule: ScanRule[];
}

export const ScanRuleQueries = {
  get,
};

export const ScanRuleMutations = {
  create,
  update,
  remove,
};
